import axios from 'axios';

export default class EmployeeService {
  async getTableData(url) {
    const response = await axios({
      method: 'get',
      url,
      withCredentials: true,
    }).catch((error) => {
      console.log('getTableData, capacities', error);
      throw error;
    });
    return response.data;
  }

  async post(url, data) {
    await axios({
      method: 'post',
      url,
      data,
      withCredentials: true,
    });
  }
}
